import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _438454a4 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _5b60d1a6 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _fbc7886e = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _04f47135 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _2451add5 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _720a6f01 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _2cd153ff = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _ffdf6dcc = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _9ca8f9ba = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _e4808578 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _7385e718 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _016f6278 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _52286604 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _73a71855 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _395521e6 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _4eef4eb8 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _b17470c2 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _25158c15 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _01c91da6 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _030c6d06 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _02c001bf = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _2564393d = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _9da84f9e = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _64887b9c = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _c794653c = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _133bcb03 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _de8fe9f6 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _37d2dc9d = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _d157848a = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _688a4c8d = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _01a342c4 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _5022fac9 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _3bdf1160 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _2f1b23d0 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _3ab0fa4c = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _c90d8e6c = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _22800de5 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _6794ad0e = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _650641b6 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _666dd3aa = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _03d6e4aa = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _91d9c812 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _7678c1e8 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _421ef645 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _5363dff0 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _2d939194 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _6b32e584 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _62586558 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _b3ad6340 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _5bcdb794 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _3e7d071b = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _6c826b63 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _6224409c = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _e46af2e4 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _4084f1c1 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _2b565126 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _5d7fb93d = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _6c75f102 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _27e235a3 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _ac8192e4 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _fe9c9f1c = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _50b96245 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _34c1ebc8 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _41751680 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _2e12458d = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _2dfd28d4 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _29e89c71 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _5f1d0d9e = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _1aa9bd06 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _f1141b6a = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _3d12cf80 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _4ba9f124 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _491e0d42 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _7d37ce30 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _df784f70 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _3be3a2e0 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _438454a4,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _5b60d1a6,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _fbc7886e,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _04f47135,
    name: "calendar"
  }, {
    path: "/customer",
    component: _2451add5,
    name: "customer"
  }, {
    path: "/details",
    component: _720a6f01,
    name: "details"
  }, {
    path: "/goals",
    component: _2cd153ff,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _ffdf6dcc,
    name: "maisoku"
  }, {
    path: "/media",
    component: _9ca8f9ba,
    name: "media"
  }, {
    path: "/privacy",
    component: _e4808578,
    name: "privacy"
  }, {
    path: "/project",
    component: _7385e718,
    name: "project"
  }, {
    path: "/response",
    component: _016f6278,
    name: "response"
  }, {
    path: "/sale",
    component: _52286604,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _73a71855,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _395521e6,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _4eef4eb8,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _b17470c2,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _25158c15,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _01c91da6,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _030c6d06,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _02c001bf,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _2564393d,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _9da84f9e,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _64887b9c,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _c794653c,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _133bcb03,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _de8fe9f6,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _37d2dc9d,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _d157848a,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _688a4c8d,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _01a342c4,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _5022fac9,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _3bdf1160,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _2f1b23d0,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _3ab0fa4c,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _c90d8e6c,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _22800de5,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _6794ad0e,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _650641b6,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _666dd3aa,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _03d6e4aa,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _91d9c812,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _7678c1e8,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _421ef645,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _5363dff0,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _2d939194,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _6b32e584,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _62586558,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _b3ad6340,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _5bcdb794,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _3e7d071b,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _6c826b63,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _6224409c,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _e46af2e4,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _4084f1c1,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _2b565126,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _5d7fb93d,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _6c75f102,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _27e235a3,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _ac8192e4,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _fe9c9f1c,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _50b96245,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _34c1ebc8,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _41751680,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _2e12458d,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _2dfd28d4,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _29e89c71,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _5f1d0d9e,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _1aa9bd06,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _f1141b6a,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _3d12cf80,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _4ba9f124,
    name: "property-property",
    children: [{
      path: "contact",
      component: _491e0d42,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _7d37ce30,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _df784f70,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _3be3a2e0,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
